import styles from '../../styles/Form.module.css';

const PayingCurrencySelect = ({ label, options = [], disabled, value, setValue, dataContent }) => {
	return (
		<div className={styles.formSelectContainer}>
			<div className={styles.formSelectInput} data-content={dataContent}>
				{
					label && <p className={styles.formInputLabel}>{label}</p>
				}
				<div className={styles.selectDiv}>

					<select
						required={true}
						className={styles.selectInputField}
						disabled={disabled} value={value}
						onChange={(e) => setValue(e.target.value)}
					>
						<option value="">Select</option>
						{
							options.map((opt, index) => {
								return (
									<option key={index} value={`${opt.currency}-${index}`}>
										{`${opt.currency}`}
									</option>
								)
							})
						}
					</select>
				</div>
			</div>
		</div>
	)
}

export default PayingCurrencySelect;
